import { createRouter, createWebHistory } from 'vue-router'

import state from '../store/user/state.js'

import userRutes from './users'

import homeRutes from './home'

// import competitionRutes from './compeition'

import panelRutes from './panel'

import torneoRutes from './torneo'

import torneoAdminRutes from './torneoAdmin.js'

import equipoRutes from './equipo.js'

import equipoAdminRutes from './equipoAdmin.js'


// const routes = homeRutes.concat(homeRutes, panelRutes, torneoRutes, torneoAdminRutes, equipoRutes)
const routes = panelRutes.concat(userRutes, torneoRutes, torneoAdminRutes, homeRutes, equipoRutes, equipoAdminRutes)

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


// guards or login
router.beforeEach((to, from, next) => {
  const isAuthenticated = state.isLoggedIn
  //
  if (to.meta.requiresAuth) {
    //
    if (!isAuthenticated) {
      if (to.meta.tipoRuta == 'T') {
        // es torneo
        next({name: 'home-detalle-torneo', params: {'idTorneo': to.params.idTorneo}})
      }
      else {
        next({name: 'login'})
      }
    } else {
      next()
    }
  }
  else { next() }
})


export default router
